<template>
  <div
    id="itsave-app-content"
    :inert="accessBlocked ? '' : null"
    :style="{ paddingTop: `${billingNoticeOffset}px` }"
  >
    <router-view :ip_prop="link"/>
  </div>
  <SubscriptionAccessGuard
    @blocking-change="accessBlocked = $event"
    @notice-offset="billingNoticeOffset = $event"
  />
  <OnboardingSupportButton />
  <!-- <footer id="foorter_version" class="fixed bottom-0 text-right w-full px-5">
    <p>Versión: 6.65.2 Beta ItSave</p>
  </footer> -->
</template>
<script>
import axios from "axios";
import OnboardingSupportButton from "./components/onboarding/OnboardingSupportButton.vue";
import SubscriptionAccessGuard from "./components/SubscriptionAccessGuard.vue";
export default {
    components: { OnboardingSupportButton, SubscriptionAccessGuard },
    data(){
        /*variables globales*/
        return {
            //local host
            link: "http://127.0.0.1:8000/",
            //pruebas
            //link: "http://18.119.109.150/",
            //produccion
            //link: "https://plataforma.itsave.cl/",
            csrfToken:'',
            csrfmiddlewaretoken:'',
            accessBlocked:false,
            billingNoticeOffset:0,
            usageHeartbeatAt:0,
            usageVisibilityHandler:null,
            usageFocusHandler:null,
            usageInteractionHandler:null,
        }
    },
    mounted(){
        window.load_axios = this.load_axios;
        window.load_response = this.load_response;
        window.load_axiosv2 = this.load_axiosv2;
        window.load_axiosv3 = this.load_axiosv3;
        window.load_responsev2 = this.load_responsev2;
        window.load_responsev3 = this.load_responsev3;
        const csrfInput = document.querySelector('input[name="csrfmiddlewaretoken"]');
        this.csrfmiddlewaretoken = csrfInput?.value || this.getCookie('csrftoken') || '';
        axios.defaults.withCredentials = true;
        axios.defaults.credentials = 'same-origin';
        if (this.csrfmiddlewaretoken) {
          this.setCookie('csrftoken', this.csrfmiddlewaretoken, 7);
        }
        this.usageVisibilityHandler = () => {
          if (document.visibilityState === 'visible') this.trackAppUsage();
        };
        this.usageFocusHandler = () => this.trackAppUsage();
        this.usageInteractionHandler = () => this.trackAppUsage();
        document.addEventListener('visibilitychange', this.usageVisibilityHandler);
        window.addEventListener('focus', this.usageFocusHandler);
        window.addEventListener('pointerdown', this.usageInteractionHandler, { passive: true });
        window.addEventListener('keydown', this.usageInteractionHandler);
        this.trackAppUsage();
        this.trackPendingPurchase();
        /* axios.defaults.headers.common['X-CSRFToken'] = this.csrfmiddlewaretoken;
        axios.defaults.headers.common['X-Csrftoken'] = this.csrfmiddlewaretoken;
        axios.defaults.xsrfCookieName = 'csrftoken'
        axios.defaults.xsrfHeaderName = 'X-CSRFToken' */
    },
    created() {
        this.csrfToken = this.getCookie('csrftoken');
    },
    beforeUnmount() {
        if (this.usageVisibilityHandler) {
          document.removeEventListener('visibilitychange', this.usageVisibilityHandler);
        }
        if (this.usageFocusHandler) {
          window.removeEventListener('focus', this.usageFocusHandler);
        }
        if (this.usageInteractionHandler) {
          window.removeEventListener('pointerdown', this.usageInteractionHandler);
          window.removeEventListener('keydown', this.usageInteractionHandler);
        }
    },
    methods:{
      async trackAppUsage() {
        if (document.visibilityState === 'hidden') return;
        const now = Date.now();
        if (now - this.usageHeartbeatAt < 5 * 60 * 1000) return;
        this.usageHeartbeatAt = now;

        const formData = new FormData();
        const companyId = window.localStorage.getItem('empresa_id');
        if (companyId) formData.append('empresa_id', companyId);

        await this.load_responsev3('registrar_uso_app', formData);
      },
      async acknowledgePurchase(transactionId) {
        const response = await this.load_responsev3(
          'api/onboarding/mercadopago/purchase-conversion',
          { transactionId },
        );
        return response?.status === 200 && response?.data?.tracked === true;
      },
      async trackPendingPurchase(attempt = 0) {
        try {
          const response = await this.load_axiosv3(
            'api/onboarding/mercadopago/purchase-conversion',
          );
          if (response?.status !== 200 || !response?.data) return;

          const purchase = response.data.purchase;
          if (!purchase) {
            if (response.data.retry && attempt < 12) {
              window.setTimeout(() => this.trackPendingPurchase(attempt + 1), 5000);
            }
            return;
          }

          const storageKey = `gtm_purchase_${purchase.transactionId}`;
          if (window.localStorage.getItem(storageKey)) {
            await this.acknowledgePurchase(purchase.transactionId);
            return;
          }

          let acknowledged = false;
          const acknowledge = async () => {
            if (acknowledged) return;
            acknowledged = true;
            const tracked = await this.acknowledgePurchase(purchase.transactionId);
            if (tracked) window.localStorage.setItem(storageKey, '1');
          };

          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ ecommerce: null });
          window.dataLayer.push({
            event: 'purchase',
            event_id: purchase.eventId,
            transaction_id: purchase.transactionId,
            value: purchase.value,
            currency: purchase.currency,
            plan: purchase.planName,
            source_path: purchase.sourcePath,
            ecommerce: {
              transaction_id: purchase.transactionId,
              value: purchase.value,
              currency: purchase.currency,
              items: [{
                item_id: purchase.planId,
                item_name: purchase.planName,
                price: purchase.value,
                quantity: 1,
              }],
            },
            eventCallback: acknowledge,
          });
        } catch (error) {
          console.error('No fue posible registrar la conversión de compra.', error);
        }
      },
      setCookie(name, value, days) {
          var expires = "";
          if (days) {
              var date = new Date();
              date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
              expires = "; expires=" + date.toUTCString();
          }
          document.cookie = name + "=" + (value || "")  + expires + "; path=/";
      },
      getCookie(name) {
          let cookieValue = null;
          if (document.cookie && document.cookie !== '') {
              const cookies = document.cookie.split(';');
              for (let i = 0; i < cookies.length; i++) {
                  const cookie = cookies[i].trim();
                  // Check if the cookie name matches the desired format
                  if (cookie.substring(0, name.length + 1) === (name + '=')) {
                      cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                      break;
                  }
              }
          }
          return cookieValue;
      },
      /*
      * Funcion que carga la respuesta de una peticion axios
      */
      load_axiosv3(url, requestConfig = {}){
        const { preserveTrailingSlash = false, ...axiosConfig } = requestConfig;
        if (!preserveTrailingSlash && url.endsWith('/')) {
          url = url.slice(0, -1);
        }
        if (url.startsWith('/')) {
          url = url.slice(1);
        }

        const storedEmpresaId = localStorage.getItem("empresa_id");
        if (storedEmpresaId && !url.includes('empresa_id=')) {
          url += (url.includes('?') ? '&' : '?') + 'empresa_id=' + storedEmpresaId;
        }

        return axios
          .get("/"+url, {
            mode: "no-cors",
            ...axiosConfig,
          })
          .then((response) => {
            return response;
          });
      },
      load_axiosv2(url, numero_funcion) {
        if (url.endsWith('/')) {
          url = url.slice(0, -1);
        }
        if (url.startsWith('/')) {
          url = url.slice(1);
        }

        const storedEmpresaId = localStorage.getItem("empresa_id");
        if (storedEmpresaId && !url.includes('empresa_id=')) {
          url += (url.includes('?') ? '&' : '?') + 'empresa_id=' + storedEmpresaId;
        }

        axios
          .get("/"+url, {
            mode: "no-cors",
          })
          .then((response) => {
            window.select_funcion(response, numero_funcion);
          });
      },
      load_axios(url, local_this, numero_funcion) {
        if (url.endsWith('/')) {
          url = url.slice(0, -1);
        }
        if (url.startsWith('/')) {
          url = url.slice(1);
        }

        const storedEmpresaId = localStorage.getItem("empresa_id");
        if (storedEmpresaId && !url.includes('empresa_id=')) {
          url += (url.includes('?') ? '&' : '?') + 'empresa_id=' + storedEmpresaId;
        }

        axios
          .get("/"+url, {
            mode: "no-cors",
          })
          .then((response) => {
            window.select_funcion(response, local_this, numero_funcion, false);
          });
      },
      /**
       * Funcion que ejecuta un post por axios y carga la promesa (respuesta)
       */
      load_response(url, selectedItem, local_this, numero_funcion) {
        if (url.endsWith('/')) {
          url = url.slice(0, -1);
        }
        if (url.startsWith('/')) {
          url = url.slice(1);
        }
        let response;
        response = axios.post("/"+url, selectedItem,{
          headers: {'X-CSRFToken': this.csrfmiddlewaretoken,
          'HTTP_X_CSRFTOKEN':this.csrfmiddlewaretoken
        },
        });
        response.then(function (result) {
          window.select_funcion(result, local_this, numero_funcion, selectedItem);
        });
      },
      load_responsev2(url, postData, numero_funcion) {
        if (url.endsWith('/')) {
          url = url.slice(0, -1);
        }
        if (url.startsWith('/')) {
          url = url.slice(1);
        }
        let response;
        response = axios.post("/"+url, postData,{
          headers: {'X-CSRFToken': this.csrfmiddlewaretoken,
          'HTTP_X_CSRFTOKEN':this.csrfmiddlewaretoken
        },
        });
        response.then(function (result) {
          window.select_funcion(result, numero_funcion);
        });
      },
      load_responsev3(url, postData, requestConfig = {}) {
        const { preserveTrailingSlash = false, ...axiosConfig } = requestConfig;
        if (!preserveTrailingSlash && url.endsWith('/')) {
          url = url.slice(0, -1);
        }
        if (url.startsWith('/')) {
          url = url.slice(1);
        }
        return axios.post("/"+url, postData,{
          ...axiosConfig,
          headers: {'X-CSRFToken': this.csrfmiddlewaretoken,
          'HTTP_X_CSRFTOKEN':this.csrfmiddlewaretoken,
          ...axiosConfig.headers,
        },
        }).then(function (result) {
          return result;
        }).catch(function (error) {
          return error;
        });
      },
      
    }
}
</script>
<style scoped>
#itsave-app-content{
    box-sizing: border-box;
    transition: padding-top .2s cubic-bezier(.4, 0, .2, 1);
}
footer{
    font-family: "Poppins", sans-serif;
    color: #4f5f6e;
}
@media (prefers-reduced-motion: reduce){
    #itsave-app-content{
        transition: none;
    }
}
</style>
